export default {
    screen: '画面',
    podZoom: '吊舱-变焦',
    podInfrared: '吊舱-红外',
    podWideAngle: '吊舱-广角',
    forwardLookingFPV: '前视FPV',
    downLookingLens: '下视镜头',
    rearViewLens: '后视镜头',
}